export default "__VITE_ASSET__ENcKgMBe__"